define('settings/lib/recordings/recordings',['require','knockout','durandal/app','api-access','mixpanel-helper','web-urls'],function (require) {
    var ko = require('knockout');
    var app = require('durandal/app');
    var userApi = require('api-access').user;
    var mixpanelHelper = require('mixpanel-helper');
    var webUrls = require('web-urls');

    return function () {
        var self = this;

        self.isTranscribeEnabled = ko.observable();
        self.isTranscribeEntitled = ko.observable();
        self.originalTranscribeSelection = ko.observable();
        self.originalSharingSelection = ko.observable();
        self.isShareRecordingContentEnabled = ko.observable();
        self.isVideoInsightsEnabled = ko.observable();
        self.isVideoInsightsEntitled = ko.observable();
        self.originalVideoInsightsSelection = ko.observable();
        self.baseUrl = webUrls.get('baseUrl');

        self.shouldShowSave = ko.computed(function () {
            return self.isTranscribeEnabled() !== self.originalTranscribeSelection() ||
              self.isShareRecordingContentEnabled() !== self.originalSharingSelection() ||
              self.isVideoInsightsEnabled() !== self.originalVideoInsightsSelection();
        });

        self.save = function () {
            var isTranscribeEnabled = self.isTranscribeEnabled();
            var isShareRecordingContentEnabled = self.isShareRecordingContentEnabled();
            var isVideoInsightsEnabled = self.isVideoInsightsEnabled();

            return userApi
                .updateSettings({
                    transcriptsEnabled: isTranscribeEnabled,
                    shareRecordingContentEnabled: isShareRecordingContentEnabled,
                    videoInsightsEnabled: isVideoInsightsEnabled
                })
                .then(function () {
                    app.trigger('settings:save');
                    self.originalTranscribeSelection(isTranscribeEnabled);
                    self.originalSharingSelection(isShareRecordingContentEnabled);
                    self.originalVideoInsightsSelection(isVideoInsightsEnabled);
                })
                .then(function () {
                    if (isTranscribeEnabled) {
                        mixpanelHelper.track('Activate Transcribe');
                    } else {
                        mixpanelHelper.track('Deactivate Transcribe');
                    }
                    if (isVideoInsightsEnabled) {
                        mixpanelHelper.track('Activate VideoInsights');
                    } else {
                        mixpanelHelper.track('Deactivate VideoInsights');
                    }
                })
                .fail(function () {
                    self.cancel();
                });
        };

        self.cancel = function () {
            self.isTranscribeEnabled(self.originalTranscribeSelection());
            self.isShareRecordingContentEnabled(self.originalSharingSelection());
            self.isVideoInsightsEnabled(self.originalVideoInsightsSelection());
        };

        self.activate = function () {
            return userApi.settings()
                .then(function (userSettings) {
                    self.isTranscribeEnabled(userSettings.transcriptsEnabled);
                    self.isTranscribeEntitled(userSettings.transcriptsEntitled);
                    self.originalTranscribeSelection(userSettings.transcriptsEnabled);
                    self.originalSharingSelection(userSettings.shareRecordingContentEnabled);
                    self.isShareRecordingContentEnabled(userSettings.shareRecordingContentEnabled);
                    self.isVideoInsightsEnabled(userSettings.videoInsightsEnabled);
                    self.isVideoInsightsEntitled(userSettings.videoInsightsEntitled);
                    self.originalVideoInsightsSelection(userSettings.videoInsightsEnabled);
                });
        };
    };
});

